document.addEventListener('DOMContentLoaded', () => {
    
    // Shopify Theme CSRF/Request context
    const csrfToken = ''; // Shopify handles its own security tokens in forms, so we don't need CSRF token

    const header = document.querySelector('header');
    const body = document.body;
    let lastScrollY = window.scrollY;

    // Dynamic Header Height calculation for zero-gap alignment
    const updateHeaderHeight = () => {
        if (header) {
            document.documentElement.style.setProperty('--header-height', `${header.offsetHeight}px`);
        }
    };
    updateHeaderHeight();
    window.addEventListener('resize', updateHeaderHeight);
    window.addEventListener('load', updateHeaderHeight);

    if (header) {
        const observer = new MutationObserver(updateHeaderHeight);
        observer.observe(header, { attributes: true, childList: true, subtree: true });
    }
    
    const alwaysFixedPages = ['cart-page', 'login-page', 'register-page'];
    const isAlwaysFixed = alwaysFixedPages.some(cls => body.classList.contains(cls));

    if (header && !isAlwaysFixed) {
        window.addEventListener('scroll', () => {
            if (document.querySelector('.main-nav.active')) {
                header.classList.remove('header-hidden');
                return;
            }

            const currentScrollY = window.scrollY;
            let hideThreshold = body.classList.contains('index-page') ? 200 : 70;

            if (currentScrollY > hideThreshold && currentScrollY > lastScrollY) {
                header.classList.add('header-hidden');
            } else {
                header.classList.remove('header-hidden');
            }
            lastScrollY = currentScrollY;
        });
    }

    // Search Panel Trigger
    const searchTrigger = document.getElementById('search-trigger');
    const searchPanel = document.getElementById('search-panel');
    const closeSearch = document.getElementById('close-search');
    const searchInput = document.getElementById('search-input');

    if(searchTrigger && searchPanel) {
        searchTrigger.addEventListener('click', (e) => {
            e.stopPropagation();
            searchPanel.classList.add('active');
            setTimeout(() => {
                searchInput.focus();
                if (typeof window.renderDefaultState === 'function') {
                    window.renderDefaultState();
                }
            }, 300);
        });

        closeSearch.addEventListener('click', () => {
            searchPanel.classList.remove('active');
        });

        document.addEventListener('click', (e) => {
            if (!searchPanel.contains(e.target) && !searchTrigger.contains(e.target)) {
                searchPanel.classList.remove('active');
            }
        });
    }

    // Hamburger Menu Mobile Dropdowns
    const hamburgerBtn = document.getElementById('hamburger-btn');
    const mainNav = document.getElementById('main-nav');
    const navOverlay = document.getElementById('menu-bg-dimmer');

    if (hamburgerBtn && mainNav && navOverlay) {
        function toggleMenu() {
            hamburgerBtn.classList.toggle('active'); 
            mainNav.classList.toggle('active');      
            navOverlay.classList.toggle('active');   

            if(mainNav.classList.contains('active')) {
                document.body.style.overflow = 'hidden';
                header.classList.remove('header-hidden'); 
            } else {
                document.body.style.overflow = '';
                setTimeout(() => {
                    if (!mainNav.classList.contains('active')) {
                        document.querySelectorAll('.dropdown, .sub-dropdown').forEach(el => {
                            el.classList.remove('active');
                        });
                        document.querySelectorAll('.dropdown-content, .sub-dropdown-content').forEach(content => {
                            content.style.maxHeight = null;
                        });
                    }
                }, 400);
            }
        }

        hamburgerBtn.addEventListener('click', (e) => {
            e.stopPropagation(); 
            toggleMenu();
        });

        navOverlay.addEventListener('click', toggleMenu);

        const dropdowns = document.querySelectorAll('.dropdown');
        dropdowns.forEach(drop => {
            const btn = drop.querySelector('.dropbtn');
            const content = drop.querySelector('.dropdown-content');
            if (btn && content) {
                btn.addEventListener('click', (e) => {
                    if (window.innerWidth <= 768) {
                        e.preventDefault(); 
                        drop.classList.toggle('active');
                        if (drop.classList.contains('active')) {
                            content.style.maxHeight = content.scrollHeight + "px";
                            setTimeout(() => {
                                if (drop.classList.contains('active')) {
                                    content.style.maxHeight = "none";
                                }
                            }, 400);
                        } else {
                            content.style.maxHeight = content.scrollHeight + "px";
                            content.offsetHeight; 
                            content.style.maxHeight = null;
                            drop.querySelectorAll('.sub-dropdown').forEach(sub => {
                                sub.classList.remove('active');
                                const subContent = sub.querySelector('.sub-dropdown-content');
                                if (subContent) subContent.style.maxHeight = null;
                            });
                        }
                    }
                });
            }
        });

        const subDropdowns = document.querySelectorAll('.sub-dropdown');
        subDropdowns.forEach(subDrop => {
            const subBtn = subDrop.querySelector('.sub-dropbtn');
            const subContent = subDrop.querySelector('.sub-dropdown-content');
            if (subBtn && subContent) {
                subBtn.addEventListener('click', (e) => {
                    if (window.innerWidth <= 768) {
                        e.preventDefault(); 
                        e.stopPropagation(); 
                        
                        const parentDropdown = subDrop.closest('.dropdown');
                        
                        if (subDrop.classList.contains('active')) {
                            subContent.style.maxHeight = subContent.scrollHeight + "px";
                            subContent.offsetHeight; 
                            subDrop.classList.remove('active');
                            subContent.style.maxHeight = null;
                        } else {
                            subDropdowns.forEach(other => {
                                if (other !== subDrop && other.closest('.dropdown') === parentDropdown) {
                                    if (other.classList.contains('active')) {
                                        const otherContent = other.querySelector('.sub-dropdown-content');
                                        if (otherContent) {
                                            otherContent.style.maxHeight = otherContent.scrollHeight + "px";
                                            otherContent.offsetHeight; 
                                            other.classList.remove('active');
                                            otherContent.style.maxHeight = null;
                                        }
                                    }
                                }
                            });
                            
                            subDrop.classList.add('active');
                            subContent.style.maxHeight = subContent.scrollHeight + "px";
                            setTimeout(() => {
                                if (subDrop.classList.contains('active')) {
                                    subContent.style.maxHeight = "none";
                                }
                            }, 400);
                        }
                    }
                });
            }
        });
    }

    // Shopify Autocomplete Search Suggestions box
    const searchWrapper = document.querySelector('.search-form-wrapper');
    const clearBtn = document.getElementById('clear-search-btn');
    const searchForm = document.getElementById('search-form');

    if (searchInput && searchWrapper) {
        const resultsBox = document.createElement('div');
        resultsBox.className = 'search-results-box';
        searchWrapper.appendChild(resultsBox);

        let searchTimeout = null;
        let focusIndex = -1;

        function getRecentSearches() {
            try {
                const data = localStorage.getItem('recent_searches');
                return data ? JSON.parse(data) : [];
            } catch (e) {
                return [];
            }
        }

        function addRecentSearch(query) {
            if (!query || query.length < 2) return;
            try {
                let recents = getRecentSearches();
                recents = recents.filter(q => q.toLowerCase() !== query.toLowerCase());
                recents.unshift(query);
                recents = recents.slice(0, 5); 
                localStorage.setItem('recent_searches', JSON.stringify(recents));
            } catch (e) {}
        }

        function removeRecentSearch(query) {
            try {
                let recents = getRecentSearches();
                recents = recents.filter(q => q.toLowerCase() !== query.toLowerCase());
                localStorage.setItem('recent_searches', JSON.stringify(recents));
            } catch (e) {}
        }

        function highlightMatch(text, query) {
            if (!query) return text;
            const words = query.split(/\s+/).filter(w => w.length >= 2);
            let result = text;
            words.forEach(word => {
                const regex = new RegExp(`(${word.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')})`, 'gi');
                result = result.replace(regex, '<strong>$1</strong>');
            });
            return result;
        }

        window.renderDefaultState = function() {
            resultsBox.innerHTML = '';
            focusIndex = -1;
            let hasContent = false;

            const recents = getRecentSearches();
            if (recents.length > 0) {
                hasContent = true;
                const title = document.createElement('div');
                title.className = 'sr-section-title';
                title.innerText = 'Recent Searches';
                resultsBox.appendChild(title);

                recents.forEach(query => {
                    const item = document.createElement('div');
                    item.className = 'sr-text-item sr-recent-item';
                    item.style.display = 'flex';
                    item.style.justifyContent = 'space-between';
                    item.style.alignItems = 'center';
                    
                    const textSpan = document.createElement('a');
                    textSpan.href = `/search?q=${encodeURIComponent(query)}`;
                    textSpan.className = 'sr-recent-link';
                    textSpan.style.flex = '1';
                    textSpan.style.color = 'inherit';
                    textSpan.style.textDecoration = 'none';
                    textSpan.innerHTML = `<span class="sr-search-icon"><svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline></svg></span> ${query}`;
                    
                    const removeBtn = document.createElement('span');
                    removeBtn.innerHTML = '&times;';
                    removeBtn.className = 'sr-remove-recent';
                    removeBtn.style.cursor = 'pointer';
                    removeBtn.style.padding = '0 5px';
                    removeBtn.style.fontSize = '1.2rem';
                    removeBtn.style.color = '#999';
                    removeBtn.style.marginLeft = '10px';
                    removeBtn.style.transition = 'color 0.2s';
                    removeBtn.onclick = (e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        removeRecentSearch(query);
                        renderDefaultState();
                    };

                    item.appendChild(textSpan);
                    item.appendChild(removeBtn);
                    resultsBox.appendChild(item);
                });
            }

            const title = document.createElement('div');
            title.className = 'sr-section-title';
            title.innerText = 'Popular Searches';
            resultsBox.appendChild(title);

            const populars = ['Necklace', 'Choker', 'Earrings', 'Budget Earrings', 'Combos'];
            populars.forEach(query => {
                const item = document.createElement('a');
                item.href = `/search?q=${encodeURIComponent(query)}`;
                item.className = 'sr-text-item sr-popular-item';
                item.innerHTML = `<span class="sr-search-icon" style="color: #e74c3c;"><svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="23 6 13.5 15.5 8.5 10.5 1 18"></polyline><polyline points="17 6 23 6 23 12"></polyline></svg></span> ${query}`;
                resultsBox.appendChild(item);
            });

            resultsBox.style.display = 'block';
        };

        if (searchForm) {
            searchForm.addEventListener('submit', function(e) {
                const query = searchInput.value.trim();
                if (query.length >= 2) {
                    addRecentSearch(query);
                }
            });
        }

        searchInput.addEventListener('input', function() {
            const query = this.value.trim();
            focusIndex = -1;
            
            if (clearBtn) {
                clearBtn.style.display = query.length > 0 ? 'block' : 'none';
            }

            if (searchTimeout) clearTimeout(searchTimeout);

            if (query.length < 2) {
                if (query.length === 0) {
                    renderDefaultState();
                } else {
                    resultsBox.innerHTML = '';
                    resultsBox.style.display = 'none';
                }
                return;
            }

            searchTimeout = setTimeout(() => {
                // Shopify Predictive Search API
                fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product,collection&resources[limit]=4`)
                    .then(res => res.json())
                    .then(data => {
                        resultsBox.innerHTML = '';
                        let hasResults = false;

                        const collections = data.resources.results.collections || [];
                        const products = data.resources.results.products || [];

                        if (collections.length > 0) {
                            hasResults = true;
                            const title = document.createElement('div');
                            title.className = 'sr-section-title';
                            title.innerText = 'Categories';
                            resultsBox.appendChild(title);

                            collections.forEach(cat => {
                                const item = document.createElement('a');
                                item.href = cat.url;
                                item.className = 'sr-text-item sr-category-item';
                                item.innerHTML = `<span class="sr-cat-icon"><svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="7" height="7"></rect><rect x="14" y="3" width="7" height="7"></rect><rect x="14" y="14" width="7" height="7"></rect><rect x="3" y="14" width="7" height="7"></rect></svg></span> ${highlightMatch(cat.title, query)}`;
                                resultsBox.appendChild(item);
                            });
                        }

                        if (products.length > 0) {
                            hasResults = true;
                            const title = document.createElement('div');
                            title.className = 'sr-section-title';
                            title.innerText = 'Products';
                            resultsBox.appendChild(title);

                            products.forEach(product => {
                                const item = document.createElement('a');
                                item.href = product.url;
                                item.className = 'search-result-item';
                                item.innerHTML = `
                                    <img src="${product.image}" alt="${product.title}" onerror="this.src='placeholder.jpg'">
                                    <div>
                                        <div class="sr-name">${highlightMatch(product.title, query)}</div>
                                        <div class="sr-price">${product.price_formatted || ('₹' + (parseFloat(product.price)).toFixed(0))}</div>
                                    </div>
                                `;
                                resultsBox.appendChild(item);
                            });
                        }

                        if (hasResults) {
                            const viewAll = document.createElement('a');
                            viewAll.href = `/search?q=${encodeURIComponent(query)}`;
                            viewAll.className = 'sr-view-all';
                            viewAll.innerText = `View all results for "${query}" →`;
                            resultsBox.appendChild(viewAll);
                        } else {
                            resultsBox.innerHTML = '<div class="sr-no-results">No results found. Try a different search term.</div>';
                        }
                        resultsBox.style.display = 'block';
                    });
            }, 250);
        });

        searchInput.addEventListener('focus', function() {
            if (this.value.trim().length === 0) {
                renderDefaultState();
            } else {
                this.dispatchEvent(new Event('input'));
            }
        });

        if (clearBtn) {
            clearBtn.addEventListener('click', function(e) {
                e.stopPropagation();
                searchInput.value = '';
                this.style.display = 'none';
                searchInput.focus();
                renderDefaultState();
            });
        }

        document.addEventListener('click', function(e) {
            if (!searchWrapper.contains(e.target) && !resultsBox.contains(e.target) && e.target !== searchInput) {
                resultsBox.style.display = 'none';
                clearKeyboardFocus();
                focusIndex = -1;
            }
        });

        function getFocusableItems() {
            return Array.from(resultsBox.querySelectorAll('a, .sr-recent-link'));
        }

        function clearKeyboardFocus() {
            getFocusableItems().forEach(item => {
                item.classList.remove('keyboard-focused');
                const parent = item.closest('.sr-text-item');
                if (parent) parent.classList.remove('keyboard-focused');
            });
        }

        searchInput.addEventListener('keydown', function(e) {
            const items = getFocusableItems();
            if (items.length === 0 || resultsBox.style.display === 'none') return;

            if (e.key === 'ArrowDown') {
                e.preventDefault();
                focusIndex++;
                if (focusIndex >= items.length) focusIndex = 0;
                highlightItem(items);
            } else if (e.key === 'ArrowUp') {
                e.preventDefault();
                focusIndex--;
                if (focusIndex < 0) focusIndex = items.length - 1;
                highlightItem(items);
            } else if (e.key === 'Escape') {
                searchPanel.classList.remove('active');
                resultsBox.style.display = 'none';
            } else if (e.key === 'Enter') {
                if (focusIndex >= 0 && focusIndex < items.length) {
                    e.preventDefault();
                    const href = items[focusIndex].getAttribute('href');
                    if (href) {
                        const cleanText = items[focusIndex].textContent.replace(/[🔥🕒⊞↗✕\s]+/g, ' ').trim();
                        if (items[focusIndex].classList.contains('sr-suggest-item') || items[focusIndex].classList.contains('sr-popular-item')) {
                            addRecentSearch(cleanText);
                        }
                        window.location.href = href;
                    }
                } else {
                    const query = searchInput.value.trim();
                    if (query.length >= 2) {
                        addRecentSearch(query);
                    }
                }
            }
        });

        function highlightItem(items) {
            clearKeyboardFocus();
            if (focusIndex >= 0 && focusIndex < items.length) {
                const activeItem = items[focusIndex];
                activeItem.classList.add('keyboard-focused');
                const parent = activeItem.closest('.sr-text-item');
                if (parent) parent.classList.add('keyboard-focused');
                activeItem.scrollIntoView({ block: 'nearest' });

                if (activeItem.classList.contains('sr-text-item') && 
                    !activeItem.classList.contains('sr-category-item') &&
                    !activeItem.classList.contains('search-result-item')) {
                    const cleanText = activeItem.textContent.replace(/[🔥🕒⊞↗✕\s]+/g, ' ').trim();
                    searchInput.value = cleanText;
                } else if (activeItem.classList.contains('sr-recent-link')) {
                    const cleanText = activeItem.textContent.replace(/[🔥🕒⊞↗✕\s]+/g, ' ').trim();
                    searchInput.value = cleanText;
                }
            }
        }
    }

    // Size Selection Modal Elements
    const modal = document.getElementById('quick-add-modal');
    const modalName = document.getElementById('qa-product-name');
    const modalVariants = document.getElementById('qa-variants-container');
    const modalAddBtn = document.getElementById('qa-confirm-btn');
    const modalClose = document.querySelector('.qa-close');
    
    let currentProductId = 0;
    let currentSelectedVariantId = 0;
    let currentQty = 1;
    let currentProductName = '';
    let currentProductPrice = 0;

    if(modalClose) {
        modalClose.addEventListener('click', () => { modal.style.display = "none"; });
        window.addEventListener('click', (e) => { if (e.target == modal) modal.style.display = "none"; });
    }

    // Product Add to Cart Logic using Shopify AJAX API
    const forms = document.querySelectorAll('.add-to-cart-form');
    forms.forEach(form => {
        form.addEventListener('submit', function(e) {
            e.preventDefault();
            
            if (this.dataset.requiresSelection === 'true') {
                const handle = this.dataset.handle;
                const name = this.dataset.name;
                const price = parseFloat(this.dataset.price || 0);
                const qtyInput = this.querySelector('.qty-input');
                currentQty = qtyInput ? qtyInput.value : 1;
                const currentForm = this;

                currentProductName = name;
                currentProductPrice = price;

                const submitBtn = this.querySelector('button[type="submit"]');
                const originalText = submitBtn ? submitBtn.innerText : "Add to Bag";
                if (submitBtn) {
                    submitBtn.innerText = "Checking...";
                    submitBtn.disabled = true;
                }
                
                // Fetch product variants from Shopify
                fetch(`/products/${handle}.js`)
                .then(res => res.json())
                .then(product => {
                    if (submitBtn) {
                        submitBtn.innerText = originalText;
                        submitBtn.disabled = false;
                    }

                    const validVariants = product.variants.filter(v => v.available);

                    if(validVariants.length === 0) {
                        showToast("Out of Stock");
                        return;
                    }

                    // Filter variants by color if data-color is specified
                    const formColor = currentForm.dataset.color ? currentForm.dataset.color.trim().toLowerCase() : '';
                    const filteredVariants = validVariants.filter(v => {
                        if (!formColor || formColor === 'default title') return true;
                        return v.options.some(opt => opt && opt.trim().toLowerCase() === formColor);
                    });

                    if(filteredVariants.length === 0) {
                        showToast("Out of Stock");
                        return;
                    }

                    // If only 1 variant matches, add directly
                    if (filteredVariants.length === 1) {
                        let varInput = currentForm.querySelector('input[name="variant_id"]');
                        if (!varInput) {
                            varInput = document.createElement('input');
                            varInput.type = 'hidden';
                            varInput.name = 'variant_id';
                            currentForm.appendChild(varInput);
                        }
                        varInput.value = filteredVariants[0].id;
                        submitCartForm(currentForm);
                        return;
                    }

                    // Multiple variants: Show size selection modal
                    if(modal) {
                        modal.style.display = "flex";
                        modalName.innerText = name;
                        modalVariants.innerHTML = '';
                        modalAddBtn.disabled = true;
                        currentProductId = product.id;
                        currentSelectedVariantId = 0;

                        filteredVariants.forEach(v => {
                            const btn = document.createElement('div');
                            btn.className = 'qa-variant-btn';
                            
                            // Display only the non-color options (e.g. just the size)
                            const displayTitle = v.options.filter(opt => opt && opt.trim().toLowerCase() !== formColor).join(' / ') || v.title;
                            btn.innerText = displayTitle;
                            
                            btn.onclick = () => {
                                document.querySelectorAll('.qa-variant-btn').forEach(b => b.classList.remove('selected'));
                                btn.classList.add('selected');
                                currentSelectedVariantId = v.id;
                                modalAddBtn.disabled = false;
                                modalAddBtn.innerText = "Add to Bag";
                            };
                            modalVariants.appendChild(btn);
                        });
                    }
                })
                .catch(err => {
                    if (submitBtn) {
                        submitBtn.innerText = originalText;
                        submitBtn.disabled = false;
                    }
                    submitCartForm(currentForm);
                });
                return; 
            }

            submitCartForm(this);
        });
    });

    if(modalAddBtn) {
        modalAddBtn.addEventListener('click', function() {
            if(!currentSelectedVariantId) return;

            const btn = this;
            const originalText = btn.innerText;
            btn.innerText = "Adding...";
            btn.disabled = true;

            const postData = {
                id: currentSelectedVariantId,
                quantity: currentQty
            };

            fetch('/cart/add.js', { 
                method: 'POST', 
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(postData) 
            })
            .then(res => res.json())
            .then(data => {
                showToast("Added to Bag Successfully");
                updateCartBadge();
                if (typeof openCartDrawer === 'function') openCartDrawer();
                modal.style.display = "none";
                if (typeof fbq !== 'undefined') {
                    fbq('track', 'AddToCart', {
                        content_name: currentProductName,
                        value: currentProductPrice,
                        currency: 'INR',
                        content_ids: [currentProductId.toString()],
                        content_type: 'product'
                    });
                }
                btn.innerText = originalText;
                btn.disabled = false;
            })
            .catch(err => {
                showToast("Error adding to bag");
                btn.innerText = originalText;
                btn.disabled = false;
            });
        });
    }

    function submitCartForm(form) {
        const btn = form.querySelector('button[type="submit"]');
        const originalText = btn.innerText;
        btn.innerText = "Adding...";
        btn.disabled = true;

        const variantId = form.querySelector('input[name="variant_id"]').value;
        const qty = form.querySelector('.qty-input') ? form.querySelector('.qty-input').value : 1;

        const postData = {
            id: variantId,
            quantity: qty
        };

        fetch('/cart/add.js', { 
            method: 'POST', 
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(postData) 
        })
        .then(res => res.json())
        .then(data => {
            showToast("Added to Bag Successfully");
            updateCartBadge();
            if (typeof openCartDrawer === 'function') openCartDrawer();
            const pid = form.dataset.id || '';
            const name = form.dataset.name || '';
            const price = parseFloat(form.dataset.price || 0);
            if (typeof fbq !== 'undefined' && name) {
                fbq('track', 'AddToCart', {
                    content_name: name,
                    value: price,
                    currency: 'INR',
                    content_ids: [pid.toString()],
                    content_type: 'product'
                });
            }
            btn.innerText = originalText;
            btn.disabled = false;
        })
        .catch(err => {
            showToast("Connection Error");
            btn.innerText = originalText;
            btn.disabled = false;
        });
    }

    updateCartBadge();

    function updateCartBadge() {
        const cartBadge = document.getElementById('cart-count');
        if(!cartBadge) return;
        fetch('/cart.js')
        .then(res => res.json())
        .then(cart => { 
            cartBadge.innerText = cart.item_count || 0; 
        });
    }

    // --- WISHLIST LOCALSTORAGE INTEGRATION ---
    function getWishlist() {
        try {
            const wish = localStorage.getItem('gina_wishlist');
            return wish ? JSON.parse(wish) : [];
        } catch (e) {
            return [];
        }
    }

    function toggleWishlist(productId, variantId) {
        const key = productId + '_' + variantId;
        const btnWishlist = document.getElementById('btn-wishlist');
        const isActive = btnWishlist ? btnWishlist.classList.contains('active') : false;
        
        let wishlist = getWishlist();
        
        if (!isActive) {
            // Add
            if (!wishlist.includes(key)) {
                wishlist.push(key);
            }
            if (btnWishlist) btnWishlist.classList.add('active');
            showToast("Added to Wishlist");
        } else {
            // Remove
            wishlist = wishlist.filter(k => k !== key);
            if (btnWishlist) btnWishlist.classList.remove('active');
            showToast("Removed from Wishlist");
        }
        
        localStorage.setItem('gina_wishlist', JSON.stringify(wishlist));
        updateWishlistBadge();
    }

    function moveToWishlist(cartKey, productId, variantId, handle) {
        let wishlist = getWishlist();
        const key = productId + '_' + (variantId || '0') + '_' + (handle || '');
        if (!wishlist.includes(key)) {
            wishlist.push(key);
            localStorage.setItem('gina_wishlist', JSON.stringify(wishlist));
        }

        const postData = {
            updates: { [cartKey]: 0 }
        };
        fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(postData)
        })
        .then(res => res.json())
        .then(cart => {
            showToast("Moved to Wishlist");
            location.reload();
        });
    }

    function moveFromWishlistToCart(productId, variantId, name, price) {
        const postData = {
            id: variantId,
            quantity: 1
        };
        fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(postData)
        })
        .then(res => res.json())
        .then(data => {
            let wishlist = getWishlist();
            const prefix = productId + '_' + (variantId || '0') + '_';
            wishlist = wishlist.filter(k => !k.startsWith(prefix) && k !== (productId + '_' + (variantId || '0')));
            localStorage.setItem('gina_wishlist', JSON.stringify(wishlist));
            
            if (typeof fbq !== 'undefined' && name) {
                fbq('track', 'AddToCart', {
                    content_name: name,
                    value: price || 0,
                    currency: 'INR',
                    content_ids: [productId.toString()],
                    content_type: 'product'
                });
            }
            showToast("Added to Bag");
            setTimeout(() => { location.reload(); }, 500);
        })
        .catch(err => {
            showToast("Error adding to bag");
        });
    }

    function removeFromWishlist(productId, variantId) {
        let wishlist = getWishlist();
        const prefix = productId + '_' + (variantId || '0') + '_';
        wishlist = wishlist.filter(k => !k.startsWith(prefix) && k !== (productId + '_' + (variantId || '0')));
        localStorage.setItem('gina_wishlist', JSON.stringify(wishlist));
        showToast("Removed from Wishlist");
        location.reload();
    }

    function updateWishlistBadge() {
        const wishBadge = document.getElementById('wishlist-count');
        if (!wishBadge) return;
        const wishlist = getWishlist();
        const count = wishlist.length;
        wishBadge.innerText = count;
        if (count > 0) {
            wishBadge.style.display = 'inline-block';
        } else {
            wishBadge.style.display = 'none';
        }
    }

    // Expose to window object for HTML onclick bindings
    window.toggleWishlist = toggleWishlist;
    window.moveToWishlist = moveToWishlist;
    window.moveFromWishlistToCart = moveFromWishlistToCart;
    window.removeFromWishlist = removeFromWishlist;
    window.updateWishlistBadge = updateWishlistBadge;
    window.showToast = showToast;

    // Call update on page load
    updateWishlistBadge();

    function showToast(message) {
        let toast = document.getElementById('toast');
        if(!toast) {
            toast = document.createElement('div');
            toast.id = 'toast';
            document.body.appendChild(toast);
        }
        
        toast.innerHTML = `<span class="toast-text">${message}</span><span class="toast-close" id="toast-close-btn">&times;</span>`;
        
        if (window.toastTimeout) {
            clearTimeout(window.toastTimeout);
        }
        
        toast.className = "toast show";
        
        const closeBtn = document.getElementById('toast-close-btn');
        if (closeBtn) {
            closeBtn.addEventListener('click', (e) => {
                e.stopPropagation();
                toast.className = "toast";
                if (window.toastTimeout) {
                    clearTimeout(window.toastTimeout);
                }
            });
        }
        
        window.toastTimeout = setTimeout(() => {
            toast.className = "toast";
        }, 4000);
    }

    // Quantity selectors helper
    document.addEventListener('click', (e) => {
        if (e.target.classList.contains('qty-change-btn')) {
            const btn = e.target;
            const container = btn.closest('.qty-selector');
            if (container) {
                const input = container.querySelector('.qty-input');
                if (input) {
                    let val = parseInt(input.value) || 1;
                    const min = parseInt(input.min) || 1;
                    const max = parseInt(input.max) || 999;
                    if (btn.classList.contains('plus')) {
                        if (val < max) input.value = val + 1;
                    } else if (btn.classList.contains('minus')) {
                        if (val > min) input.value = val - 1;
                    }
                    input.dispatchEvent(new Event('change'));
                }
            }
        }
    });

    // Horizontal Scrolling wrappers helper
    function updateScrollSliders() {
        document.querySelectorAll('.h-scroll-section').forEach(section => {
            const wrapper = section.querySelector('.scrolling-wrapper');
            const leftBtn = section.querySelector('.scroll-btn.left');
            const rightBtn = section.querySelector('.scroll-btn.right');
            if (wrapper) {
                const hasOverflow = wrapper.scrollWidth > wrapper.clientWidth;
                if (leftBtn && rightBtn) {
                    if (hasOverflow) {
                        leftBtn.style.display = '';
                        rightBtn.style.display = '';
                    } else {
                        leftBtn.style.display = 'none';
                        rightBtn.style.display = 'none';
                    }
                }
                if (!hasOverflow) {
                    wrapper.classList.add('justify-center');
                } else {
                    wrapper.classList.remove('justify-center');
                }
            }
        });
    }

    setTimeout(updateScrollSliders, 100);
    window.addEventListener('resize', updateScrollSliders);
    initCollectionCountdowns();
});

function scrollSection(btn, distance) {
    const wrapper = btn.parentNode.querySelector('.scrolling-wrapper');
    wrapper.scrollBy({ left: distance, behavior: 'smooth' });
}

function toggleAccordion(button) {
    const item = button.parentElement;
    item.classList.toggle('active');
}

function initCollectionCountdowns() {
    const countdowns = document.querySelectorAll('.collection-countdown');
    countdowns.forEach(el => {
        const endTimeStr = el.getAttribute('data-end');
        if (!endTimeStr) return;
        
        const t = endTimeStr.split(/[- :]/);
        if (t.length < 3) return;
        const endTime = new Date(t[0], t[1] - 1, t[2], t[3] || 0, t[4] || 0, t[5] || 0).getTime();
        
        function updateTimer() {
            const now = new Date().getTime();
            const distance = endTime - now;
            
            if (distance < 0) {
                el.style.display = 'none';
                return;
            }
            
            const days = Math.floor(distance / (1000 * 60 * 60 * 24));
            const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((distance % (1000 * 60)) / 1000);
            
            let html = '';
            if (days > 0) {
                html += `<span class="time-block days">${days}d</span> `;
            }
            html += `<span class="time-block hours">${String(hours).padStart(2, '0')}h</span> : `;
            html += `<span class="time-block minutes">${String(minutes).padStart(2, '0')}m</span> : `;
            html += `<span class="time-block seconds">${String(seconds).padStart(2, '0')}s</span>`;
            
            el.innerHTML = html;
        }
        
        updateTimer();
        setInterval(updateTimer, 1000);
    });
}

// --- Recent Purchases Toast Notification System ---
document.addEventListener("DOMContentLoaded", function() {
    if (!window.purchaseEventsData || window.purchaseEventsData.length === 0) {
        return;
    }

    const toast = document.createElement("div");
    toast.className = "purchase-toast";
    toast.innerHTML = `
        <img class="purchase-toast-img" src="" alt="Product Image">
        <div class="purchase-toast-content">
            <button class="purchase-toast-close" aria-label="Close">&times;</button>
            <div class="purchase-toast-title"></div>
            <div class="purchase-toast-product"></div>
            <div class="purchase-toast-time"></div>
        </div>
    `;
    document.body.appendChild(toast);

    const toastImg = toast.querySelector(".purchase-toast-img");
    const toastTitle = toast.querySelector(".purchase-toast-title");
    const toastProduct = toast.querySelector(".purchase-toast-product");
    const toastTime = toast.querySelector(".purchase-toast-time");
    const toastClose = toast.querySelector(".purchase-toast-close");

    toastClose.addEventListener("click", function(e) {
        e.stopPropagation();
        toast.classList.remove("show");
    });

    let displayTimeout = null;

    function showRandomPurchase() {
        if (toast.classList.contains("show")) {
            toast.classList.remove("show");
            setTimeout(updateAndShow, 500);
        } else {
            updateAndShow();
        }
    }

    function updateAndShow() {
        if (!window.purchaseEventsData || window.purchaseEventsData.length === 0) return;
        
        const randomIndex = Math.floor(Math.random() * window.purchaseEventsData.length);
        const event = window.purchaseEventsData[randomIndex];

        toastImg.src = event.image_url || 'placeholder.jpg';
        toastImg.onerror = function() {
            this.src = 'placeholder.jpg';
        };
        toastTitle.innerHTML = `<strong>${escapeHtml(event.buyer_name)}</strong> from <strong>${escapeHtml(event.buyer_location)}</strong> purchased`;
        toastProduct.textContent = event.product_name;
        toastTime.textContent = event.time_text;

        toast.style.cursor = "pointer";
        toast.onclick = function(e) {
            if (e.target !== toastClose && !toastClose.contains(e.target)) {
                window.location.href = event.product_url;
            }
        };

        toast.classList.add("show");

        if (displayTimeout) clearTimeout(displayTimeout);
        displayTimeout = setTimeout(() => {
            toast.classList.remove("show");
        }, 8000);
    }

    function escapeHtml(text) {
        const div = document.createElement('div');
        div.textContent = text;
        return div.innerHTML;
    }

    setTimeout(showRandomPurchase, 10000);
    setInterval(showRandomPurchase, 60000);
});

document.addEventListener("DOMContentLoaded", function() {
    // --- CART DRAWER LOGIC ---
    const cartIconBtn = document.getElementById('cart-icon-btn');
    const cartDrawer = document.getElementById('cart-drawer');
    const cartDrawerOverlay = document.getElementById('cart-drawer-overlay');
    const cartDrawerClose = document.getElementById('cart-drawer-close');

    if (cartIconBtn && cartDrawer && cartDrawerOverlay) {
        cartIconBtn.addEventListener('click', (e) => {
            if (window.location.pathname === '/cart') {
                return; // Allow normal navigation on cart page
            }
            e.preventDefault();
            openCartDrawer();
        });

        if (cartDrawerClose) {
            cartDrawerClose.addEventListener('click', closeCartDrawer);
        }

        cartDrawerOverlay.addEventListener('click', closeCartDrawer);
    }

    function openCartDrawer() {
        if (window.location.pathname === '/cart') {
            return; // Do not open drawer on cart page
        }
        if (cartDrawer && cartDrawerOverlay) {
            renderCartDrawer();
            cartDrawer.classList.add('active');
            cartDrawerOverlay.classList.add('active');
            document.body.style.overflow = 'hidden'; // prevent page scroll
        }
    }

    function closeCartDrawer() {
        if (cartDrawer && cartDrawerOverlay) {
            cartDrawer.classList.remove('active');
            cartDrawerOverlay.classList.remove('active');
            document.body.style.overflow = ''; // restore scroll
        }
    }

    function renderCartDrawer() {
        const dynamicContent = document.getElementById('cart-drawer-dynamic-content');
        if (!dynamicContent) return;

        fetch('/?sections=header')
        .then(res => res.json())
        .then(sections => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(sections.header, 'text/html');
            
            const newContent = doc.getElementById('cart-drawer-dynamic-content');
            if (newContent) {
                dynamicContent.innerHTML = newContent.innerHTML;
            }

            const newBadge = doc.getElementById('cart-count');
            const currentBadge = document.getElementById('cart-count');
            if (newBadge && currentBadge) {
                currentBadge.innerText = newBadge.innerText;
            }
        })
        .catch(err => {
            console.error("Failed to load cart drawer:", err);
        });
    }

    function updateDOMWithSections(sections) {
        if (!sections) return;
        const parser = new DOMParser();

        if (sections.header) {
            const doc = parser.parseFromString(sections.header, 'text/html');
            const newContent = doc.getElementById('cart-drawer-dynamic-content');
            const currentContent = document.getElementById('cart-drawer-dynamic-content');
            if (newContent && currentContent) {
                currentContent.innerHTML = newContent.innerHTML;
            }

            const newBadge = doc.getElementById('cart-count');
            const currentBadge = document.getElementById('cart-count');
            if (newBadge && currentBadge) {
                currentBadge.innerText = newBadge.innerText;
            }
        }

        if (sections['main-cart']) {
            const doc = parser.parseFromString(sections['main-cart'], 'text/html');
            const newContainer = doc.querySelector('.cart-page-container');
            const currentContainer = document.querySelector('.cart-page-container');
            if (newContainer && currentContainer) {
                currentContainer.innerHTML = newContainer.innerHTML;
            }
            if (typeof window.initWishlistOnCart === 'function') {
                window.initWishlistOnCart();
            }
            if (typeof window.initCheckoutIntercept === 'function') {
                window.initCheckoutIntercept();
            }
        }
    }

    // Globally expose functions for inline events
    window.changeDrawerQty = function(key, newQty) {
        // Disable buttons inside the selector to prevent double-clicks
        const buttons = document.querySelectorAll(`button[onclick*="${key}"]`);
        buttons.forEach(btn => btn.disabled = true);

        const isCartPage = window.location.pathname === '/cart';
        const requestedSections = isCartPage ? 'header,main-cart' : 'header';

        fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ 
                id: key, 
                quantity: newQty,
                sections: requestedSections
            })
        })
        .then(res => res.json())
        .then(response => {
            if (response.sections) {
                updateDOMWithSections(response.sections);
            } else {
                renderCartDrawer();
                if (isCartPage && typeof window.refreshCartPage === 'function') {
                    window.refreshCartPage();
                }
            }
        })
        .catch(err => {
            console.error("Error changing qty:", err);
            renderCartDrawer();
        });
    };

    window.removeDrawerItem = function(key) {
        const isCartPage = window.location.pathname === '/cart';
        const requestedSections = isCartPage ? 'header,main-cart' : 'header';

        fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ 
                id: key, 
                quantity: 0,
                sections: requestedSections
            })
        })
        .then(res => res.json())
        .then(response => {
            if (response.sections) {
                updateDOMWithSections(response.sections);
            } else {
                renderCartDrawer();
                if (isCartPage && typeof window.refreshCartPage === 'function') {
                    window.refreshCartPage();
                }
            }
        })
        .catch(err => {
            console.error("Error removing item:", err);
            renderCartDrawer();
        });
    };

    // Expose openCartDrawer globally so AJAX functions can open it on ATC
    window.openCartDrawer = openCartDrawer;
    window.renderCartDrawer = renderCartDrawer;
    window.updateDOMWithSections = updateDOMWithSections;
});